import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Icon from '../../../components/Icon';
import AppModal from '../../../components/Modal';
import { removeOrganizationInvite } from '../../../actions/api';
import * as types from '../../../constants/ActionTypes';
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export const withRemoveInvitationConfirmModal = (WrappedComponent) => connect(void 0, mapDispatchToProps)(withTranslation()(class RemoveInvitationConfirmModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            processing: false,
            organization: {},
            email: '',
            callback: () => void 0,
        };
        this.handleCloseModal = () => {
            this.setState({ open: false });
        };
        this.handleClick = (organization, email, callback) => {
            this.setState({
                open: true,
                processing: false,
                organization: organization,
                email: email,
                callback: callback || (() => void 0),
            });
        };
        this.handleSubmit = (event) => {
            if (event) {
                event.preventDefault();
            }
            this.setState({
                processing: true,
            });
            this.props
                // @ts-expect-error TS2339: Property name does not exist on type {}
                .dispatch(removeOrganizationInvite(this.state.organization.name, this.state.email))
                .then((action) => {
                if (action.type === types.REMOVE_ORGANIZATION_INVITE_SUCCESS) {
                    this.setState({
                        open: false,
                        processing: false,
                    });
                    this.state.callback();
                }
            });
        };
    }
    renderModal() {
        const { t } = this.props;
        const { organization, email, processing } = this.state;
        return (_jsxs(Modal, { isOpen: true, toggle: this.handleCloseModal, autoFocus: false, children: [_jsx(ModalHeader, { toggle: this.handleCloseModal, children: t('organizations.removeInvitationTitle') }), _jsx(ModalBody, { children: _jsx("p", { children: t('organizations.removeInvitationDescription', {
                            email: email,
                            // @ts-expect-error TS2339: Property name does not exist on type {}
                            organization: organization ? organization.name : '',
                        }) }) }), _jsxs(ModalFooter, { children: [_jsxs(Button, { color: "primary", onClick: this.handleSubmit, disabled: processing, children: [!processing ? null : _jsx(Icon, { name: "spinner", fixedWidth: true, spin: true, className: "mr-2" }), t('organizations.removeInvitation')] }), _jsx(Button, { color: "light", onClick: this.handleCloseModal, children: t('cancel') })] })] }));
    }
    render() {
        return (_jsxs("div", { children: [_jsx(WrappedComponent, { ...this.props, onRemoveInvitationClick: this.handleClick }), !this.state.open ? null : _jsx(AppModal, { children: this.renderModal() })] }));
    }
}));
